import type { LeadsInt32ItemsFilter } from '@app/api/Leads/types';

import type { LeadsRegistrySearchFilterBody } from './buildLeadsRegistrySearchFilter';

const sortNumbers = (values: number[] | null): number[] =>
  values ? [...values].sort((a, b) => a - b) : [];

const sortStrings = (values: string[] | null): string[] =>
  values ? [...values].sort((a, b) => a.localeCompare(b)) : [];

const normalizeTagFilter = (filter: LeadsInt32ItemsFilter) => ({
  OuterInclude: filter.OuterInclude,
  InnerInclude: filter.InnerInclude ?? null,
  ItemIds: sortNumbers(filter.ItemIds),
});

// Deterministic signature for a built `SearchLeads` filter body. The registry
// search effect compares this signature instead of relying on object identity,
// so a new `SearchLeads` request is sent only when the effective filters
// actually change. Array fields are sorted (their order is not meaningful for
// the backend filter) and empty/`null` arrays normalize to `[]`, so equivalent
// filters always serialize to the same string regardless of selection order or
// render churn.
export const buildLeadsRegistrySearchSignature = (
  filter: LeadsRegistrySearchFilterBody
): string =>
  JSON.stringify({
    SearchTerm: filter.SearchTerm ?? null,
    SearchTermIn: filter.SearchTermIn ?? null,
    DateCreateS: filter.DateCreateS ?? null,
    DateCreateE: filter.DateCreateE ?? null,
    DateActiveS: filter.DateActiveS ?? null,
    DateActiveE: filter.DateActiveE ?? null,
    UserIds: sortNumbers(filter.UserIds),
    IntegrationIds: sortNumbers(filter.IntegrationIds),
    StatusIds: sortStrings(filter.StatusIds),
    CrmTaskStatusIds: sortStrings(filter.CrmTaskStatusIds),
    ChannelIds: sortStrings(filter.ChannelIds),
    BranchIds: sortNumbers(filter.BranchIds),
    TagFilters: (filter.TagFilters ?? []).map(normalizeTagFilter),
    SalesFunnelsStages: sortNumbers(filter.SalesFunnelsStages),
  });
